import { render } from "./PortfolioCard.vue?vue&type=template&id=49a2209f&scoped=true"
import script from "./PortfolioCard.vue?vue&type=script&lang=js"
export * from "./PortfolioCard.vue?vue&type=script&lang=js"

import "./PortfolioCard.vue?vue&type=style&index=0&id=49a2209f&scoped=true&lang=css"

import exportComponent from "/Users/josiahsprankle/Desktop/personal/JDS-Music-Site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a2209f"]])

export default __exports__